import envConfigObj from './const/environment/envConfig';

const envHelper = {

    setEnvironmentURLs() {
        const hostname = window && window.location && window.location.hostname;
        if(hostname){
            if(hostname.includes("dev")){
                return  envConfigObj["dev"];
            } else if(hostname.includes("tst")){
                return  envConfigObj["tst"];
            } else if(hostname.includes("acc")){
                return  envConfigObj["acc"];
            } else {
                return  envConfigObj["prod"];
            }
        } else {
            return  envConfigObj["prod"];
        }
    }
}

export default envHelper;